function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hex-uptrend_svg__clip0_2_278)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.218,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.523.625l34.31 19.81v39.618l-34.31 19.809-34.31-19.81V20.435L34.522.625z",
  fill: "#0043C5"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.343,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.52 5.47l29.515 16.954v33.91L43.52 73.287 14.003 56.333v-33.91L43.519 5.47z",
  fill: "#0043C5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.591 10.66l25.62 14.791v29.584l-25.62 14.792-25.62-14.792V25.451L54.59 10.66z",
  fill: "#0043C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.767 48.921V30.283a.93.93 0 00-.922-.938.93.93 0 00-.922.938v19.576a.93.93 0 00.922.938h26.53a.93.93 0 00.921-.938.93.93 0 00-.921-.938H42.767z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.214 42.24l5.075 3.683c.387.28.931.09 1.066-.372l2.266-7.825 2.032 3.867a.687.687 0 001.208.023l6.228-10.873a.706.706 0 00-.25-.958.686.686 0 00-.945.254l-5.605 9.784-2.244-4.27a.688.688 0 00-1.273.131l-2.47 8.525-4.843-3.515a.685.685 0 00-.963.16l-3.328 4.68a.707.707 0 00.157.979c.31.226.741.155.964-.159l2.925-4.114z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.492 28.497l-.295 4.94-3.811-2.213 4.105-2.727z",
  fill: "#fff",
  stroke: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "hex-uptrend_svg__clip0_2_278"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h80v80H0z"
})));

function SvgHexUptrend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgHexUptrend;